import { createStore, applyMiddleware, compose } from "redux";
import multi from "redux-multi";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import promise from "redux-promise";
import thunk from "redux-thunk";

import rootReducer from "../reducers/index";

const persistConfig = {
  key: "root",
  storage,
  /* `chat` guarda apenas se o widget de FAQ está aberto — estado de tela, não
     dado do usuário. Sem estar aqui, o redux-persist gravava `showChat: true`
     no localStorage e reabria o chat sozinho a cada carregamento da página,
     para sempre, mesmo depois de sair e entrar de novo. */
  blacklist: ["note", "layout", "form", "toastr", "socket", "chat"]
  // whitelist: ['user','language','general']
};

const persistedReducer = persistReducer(persistConfig, rootReducer);
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
  persistedReducer,
  composeEnhancers(applyMiddleware(thunk, promise, multi))
);
const persistor = persistStore(store);

export { store, persistor };
